<div class="items-container border rounded px-2 py-1">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="font-weight-bold">{{ title | titlecase }}</span>
      <button class="btn btn-default" (click)="toggleList()">
        @if (closedList) {
          <i class="far fa-chevron-down"></i>
        }
        @if (!closedList) {
          <i class="far fa-chevron-up"></i>
        }
      </button>
    </div>
    <div class="selected-list d-inline-block text-truncate">
      {{ selectedList | uppercase }}
    </div>
  </div>
  @if (!closedList) {
    <div class="items-list">
      <div class="d-flex justify-content-between all-selection">
        <mat-checkbox
          (change)="selectAllItems()"
          [checked]="allSelected"
          [disabled]="disabled">
          {{'COMMON.ALL' | translate}}
        </mat-checkbox>
        <span class="pt-1 font-weight-bold">{{ getSelected }} {{'COMMON.OF' | translate}} {{ items?.length }}</span>
      </div>
      <div class="d-flex">
        @for (item of items; track $index) {
          <div class="items-selections-container">
            <div class="items-selections">
              <mat-checkbox
                [checked]="item.selected"
                [disabled]="disabled"
                (change)="selectItem($event, item)">
                {{ item.code | uppercase}}
              </mat-checkbox>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>